import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for LandingPage
 *
 */

const LandingPage = lazyLoad(
  () => import('app/modules/Landing'),
  (module) => module.default,
);

export default LandingPage;
